import en from './en';
import type { TranslationSchema } from './en';

const gu: TranslationSchema = {
    ...en,
};

export default gu;
